<script lang="ts">
    export let isOpen: boolean = true;
    export let title: string = "Title";
</script>

{#if isOpen}
    <div class="toolbox-box">
        <h3 class="border-bottom pb-1">{title}</h3>
        <div class="toolbox-box-content" >
            <slot />
        </div>
    </div>
{/if}

<style>
    .toolbox-box {
        position: absolute;
        height: 100%;
        right: 0px;
        width: 330px;
        background-color: white;
        z-index: 1;
        padding: 10px 20px 20px 20px;
    }

    .toolbox-box-content {
        overflow-y: scroll;
        height: calc(100% - 50px);
    }
</style>
